import React, { useState, useMemo, useRef, useEffect } from "react";


// const PropertyList = ({ parcels = [] }) => {
const PropertyList = ({
    parcels = [],
    onRowClick,
    selectedParcelId,
    setSelectedParcelId,
    sortKey: propSortKey,
    setSortKey: propSetSortKey,
    sortDir: propSortDir,
    setSortDir: propSetSortDir,
    currentZoom,
    loadMore,
    hasMore,
    isLoadingMore = false,
    isAdjacentMode = false
}) => {
    const loadMoreTargetRef = useRef(null);
    const previousCountRef = useRef(parcels.length);
    // Removed: Last row highlight feature
    // const [lastLoadedIndex, setLastLoadedIndex] = useState(-1);

    // Track when new records are loaded - DISABLED
    // useEffect(() => {
    //     if (!isLoadingMore && parcels.length > previousCountRef.current) {
    //         // Mark the last index of the previous batch
    //         setLastLoadedIndex(previousCountRef.current - 1);

    //         // Clear the highlight after 3 seconds
    //         setTimeout(() => {
    //             setLastLoadedIndex(-1);
    //         }, 3000);
    //     }
    //     previousCountRef.current = parcels.length;
    // }, [parcels.length, isLoadingMore]);

    // Infinite scroll: Auto-load when scrolling near bottom
    useEffect(() => {
        if (!loadMoreTargetRef.current || !hasMore || isLoadingMore) return;

        const observer = new IntersectionObserver(
            (entries) => {
                // When the target element becomes visible, load more
                if (entries[0].isIntersecting && hasMore && !isLoadingMore) {
                    console.log('Infinite scroll triggered - loading more...');
                    loadMore();
                }
            },
            {
                root: null, // viewport
                rootMargin: '200px', // Trigger 200px before reaching the element
                threshold: 0.1
            }
        );

        observer.observe(loadMoreTargetRef.current);

        return () => {
            if (loadMoreTargetRef.current) {
                observer.unobserve(loadMoreTargetRef.current);
            }
        };
    }, [hasMore, isLoadingMore, loadMore]);

    // Auto-scroll to newly loaded content
    // useEffect(() => {
    //     if (!isLoadingMore && parcels.length > previousCountRef.current && loadMoreTargetRef.current) {
    //         // Scroll to the newly loaded section
    //         setTimeout(() => {
    //             loadMoreTargetRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    //         }, 100);
    //     }
    //     previousCountRef.current = parcels.length;
    // }, [parcels.length, isLoadingMore]);

    // Use local state for client-side sorting
    // Use parent props for API sorting
    const [localSortKey, setLocalSortKey] = useState('spreadpercentage');
    const [localSortDir, setLocalSortDir] = useState('desc');

    // Use API sorting if parent is controlling sort (provides setSortKey callback)
    const useApiSorting = propSetSortKey !== undefined && propSetSortKey !== null;
    const sortKey = useApiSorting && propSortKey !== undefined ? propSortKey : localSortKey;
    const setSortKey = useApiSorting && propSetSortKey ? propSetSortKey : setLocalSortKey;
    const sortDir = useApiSorting && propSortDir !== undefined ? propSortDir : localSortDir;
    const setSortDir = useApiSorting && propSetSortDir ? propSetSortDir : setLocalSortDir;

    const toggleSort = (key) => {
        if (sortKey === key) {
            setSortDir((d) => (d === "asc" ? "desc" : "asc"));
        } else {
            setSortKey(key);
            setSortDir("asc");
        }
    };

    const parseNumber = (v) => {
        if (v === null || v === undefined) return NaN;
        const n = Number(String(v).replace(/[^0-9.-]/g, ""));
        return Number.isFinite(n) ? n : NaN;
    };

    // Normalize incoming parcels (if GeoJSON features, use .properties)
    const normalizedItems = useMemo(() => {
        if (!Array.isArray(parcels)) return [];
        return parcels.map((it) => {
            if (!it) return {};
            if (it.properties && typeof it.properties === "object") return { ...it.properties, __feature__: it };
            return { ...it };
        });
    }, [parcels]);

    // Sorting implementation that pushes non-numeric values to the end
    const sortedParcels = useMemo(() => {
        if (!normalizedItems || normalizedItems.length === 0) return [];
        if (!sortKey) return normalizedItems;

        // const getKeyVal = (item) => {
        //     if (sortKey === "totalunits") {
        //         return parseNumber(item.totalunits ?? item.total_units ?? item.units ?? item.Unit);
        //     }
        //     if (sortKey === "totallandvalue") {
        //         return parseNumber(
        //             item.totallandvalue ??
        //             item.total_land_value ??
        //             item.totallandvalue_usd ??
        //             item.totallandvalue ??
        //             item.landvalue ??
        //             item.land_value ??
        //             item.totalvalue ??
        //             item.total_value
        //         );
        //     }
        //     // NEW: Spread % sorting
        //     if (sortKey === "spreadpercentage") {
        //         return parseNumber(
        //             item.spreadpercentage ??
        //             item.spreadPercent ??
        //             item.spread_percentage ??
        //             item.spread_percent
        //         );
        //     }
        //     return NaN;
        // };

        const getKeyVal = (item) => {
            if (sortKey === "totalunits") {
                return parseNumber(item.totalunits ?? item.total_units ?? item.units ?? item.Unit);
            }

            if (sortKey === "totallandvalue") {
                return parseNumber(
                    item.totallandvalue ??
                    item.total_land_value ??
                    item.totallandvalue_usd ??
                    item.landvalue ??
                    item.land_value ??
                    item.totalvalue ??
                    item.total_value
                );
            }

            //  PRICE Zestimate
            if (sortKey === "zestimate") {
                return parseNumber(
                    item.zestimate ??
                    item.price ??
                    item.saleprice ??
                    item.sale_price
                );
            }

            //  SIZE Parcel size
            if (sortKey === "parcelsize") {
                return parseNumber(
                    item.parcelsize ??
                    item.parcel_size ??
                    item.landsize ??
                    item.land_size
                );
            }

            // Spread %
            if (sortKey === "spreadpercentage") {
                return parseNumber(
                    item.spreadpercentage ??
                    item.spreadPercent ??
                    item.spread_percentage ??
                    item.spread_percent
                );
            }

            return NaN;
        };


        const cmp = (a, b) => {
            const na = getKeyVal(a);
            const nb = getKeyVal(b);
            const aValid = Number.isFinite(na);
            const bValid = Number.isFinite(nb);
            if (!aValid && !bValid) return 0;
            if (!aValid) return 1; // push invalid (N/A) to end
            if (!bValid) return -1;
            return na < nb ? -1 : na > nb ? 1 : 0;
        };

        // IMPORTANT: Don't re-sort if using API sorting (pagination)
        // The API already sorted the data, re-sorting changes row positions
        if (useApiSorting) {
            return normalizedItems; // Preserve API sort order
        }

        const arr = [...normalizedItems].sort((a, b) => {
            const r = cmp(a, b);
            return sortDir === "asc" ? r : -r;
        });
        return arr;
    }, [normalizedItems, sortKey, sortDir, useApiSorting]);

    const handleRowClick = (item, index) => {
        // Use parcel ID instead of index for selection
        const parcelId = item.parcel || item.parcelid || item.geo_id || item.id;

        // Only set selection if setSelectedParcelId is provided
        if (setSelectedParcelId) {
            setSelectedParcelId(parcelId); // Highlight selected row by ID
        }

        console.log("Row clicked:", item); // ✅ ADD: Debug log
        console.log("Coordinates:", item.latitude, item.longitude); // ✅ ADD: Check coords

        if (onRowClick && typeof onRowClick === "function") {
            // Pass the full property object to parent
            onRowClick(item);
        } else {
            console.warn("onRowClick is not a function or not provided"); // ✅ ADD: Warning
        }
    };

    return (
        <div
            className="listOuter"
            style={{
                width: "100%",
                height: "100%",
            }}
        >
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                }}
            >
                {/* Header */}
                <div style={{ flex: 1, height: "100%" }}  >
                    {parcels.length === 0 ? (
                        <div style={{ padding: "10px", textAlign: "center", color: "#777" }}>
                            No Records Found
                        </div>
                    ) : (
                        <>
                            <table
                                className="property-table"
                                style={{
                                    //tableLayout: "auto", // let columns size naturally
                                    tableLayout: "fixed",
                                    minWidth: "1200px",
                                    width: "100%", // ensure table can overflow to show horizontal scroll
                                    borderCollapse: "collapse",
                                }}
                            >
                                <thead>
                                    <tr
                                        style={{
                                            background: "#e0e0e0",
                                            fontWeight: "bold",
                                            borderBottom: "1px solid #ccc",
                                        }}
                                    >
                                        <th style={{ textAlign: "center", padding: "8px", width: "50px" }}>#</th>
                                        <th style={{ textAlign: "left", padding: "8px", ...(isAdjacentMode ? { width: "120px" } : {}) }}>{isAdjacentMode ? "Parcels" : "Parcel"}</th>
                                        <th style={{ textAlign: "center", padding: "8px" }}>Muni</th>
                                        {/* <th style={{ 
        textAlign: "left", 
        padding: "8px 12px", 
        whiteSpace: "nowrap",
        width: "auto",        
      }}>
        Parcel
      </th> */}

                                        {/* <th style={{ textAlign: "right", padding: "8px" }}>Size</th> */}
                                        <th
                                            style={{
                                                textAlign: "right",
                                                padding: "8px",
                                                cursor: "pointer",
                                                userSelect: "none",
                                            }}
                                            onClick={() => toggleSort("parcelsize")}
                                        >
                                            Size
                                            <span style={{ fontSize: 11 }}>
                                                {sortKey === "parcelsize" ? (sortDir === "asc" ? "▲" : "▼") : "↕"}
                                            </span>
                                        </th>


                                        <th style={{ textAlign: "right", padding: "8px" }}>Zoning</th>

                                        {/* <th style={{ textAlign: "right", padding: "8px" }}>sqft Price</th> */}
                                        <th style={{ textAlign: "right", padding: "8px" }}>Target ARV</th>
                                        <th style={{ textAlign: "right", padding: "8px" }}>Land value/Unit</th>

                                        {isAdjacentMode && (
                                            <th style={{ textAlign: "center", padding: "8px" }}>Townhouses</th>
                                        )}

                                        <th
                                            style={{
                                                textAlign: "right",
                                                padding: "8px",
                                                cursor: "pointer",
                                                userSelect: "none",
                                                alignItems: "center",
                                                gap: 6,
                                            }}
                                            onClick={() => toggleSort("totalunits")}
                                        >
                                            Max Unit
                                            <span style={{ fontSize: 11 }}>{sortKey === "totalunits" ? (sortDir === "asc" ? "▲" : "▼") : "↕"}</span>
                                        </th>
                                        {/* <th title="ESTIMATED POST DEVELOPED VALUE"
                                            style={{
                                                textAlign: "right",
                                                padding: "8px",
                                                cursor: "pointer",
                                                userSelect: "none",
                                                alignItems: "center",
                                                gap: 6,
                                            }}
                                            onClick={() => toggleSort("totallandvalue")}
                                        >
                                            20% Dev. value
                                            <span style={{ fontSize: 11 }}>{sortKey === "totallandvalue" ? (sortDir === "asc" ? "▲" : "▼") : "↕"}</span>
                                        </th> */}

                                        <th
                                            title="ESTIMATED POST DEVELOPED VALUE"
                                            style={{
                                                textAlign: "right",
                                                padding: "8px",
                                                cursor: "pointer",
                                                userSelect: "none",
                                            }}
                                            onClick={() => toggleSort("totallandvalue")}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "flex-end",
                                                    gap: 6,
                                                    minWidth: 0, // for ellipsis in flex
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        whiteSpace: "nowrap",
                                                        minWidth: 0,
                                                        flex: 1, // Text takes remaining space
                                                    }}
                                                >
                                                    20% Dev. value
                                                </span>

                                                <span
                                                    style={{
                                                        fontSize: 11,
                                                        flexShrink: 0, // ICON NEVER SHRINKS
                                                    }}
                                                >
                                                    {sortKey === "totallandvalue"
                                                        ? sortDir === "asc"
                                                            ? "▲"
                                                            : "▼"
                                                        : "↕"}
                                                </span>
                                            </div>
                                        </th>

                                        {/* <th title="SALES PRICE" style={{ textAlign: "right", padding: "8px" }}>Price</th> */}
                                        <th
                                            title="SALES PRICE"
                                            style={{
                                                textAlign: "right",
                                                padding: "8px",
                                                cursor: "pointer",
                                                userSelect: "none",
                                            }}
                                            onClick={() => toggleSort("zestimate")}
                                        >
                                            Price
                                            <span style={{ fontSize: 11 }}>
                                                {sortKey === "zestimate" ? (sortDir === "asc" ? "▲" : "▼") : "↕"}
                                            </span>
                                        </th>

                                        <th style={{ textAlign: "right", padding: "8px" }}>Spread</th>
                                        {/* <th style={{ textAlign: "right", padding: "8px" }}>Spread %</th> */}
                                        <th
                                            style={{
                                                textAlign: "right",
                                                padding: "8px",
                                                cursor: "pointer",
                                                userSelect: "none",
                                                alignItems: "center",
                                                gap: 6,
                                            }}
                                            onClick={() => toggleSort("spreadpercentage")}
                                        >
                                            Spread(%)
                                            <span style={{ fontSize: 11 }}>
                                                {sortKey === "spreadpercentage" ? (sortDir === "asc" ? "▲" : "▼") : "↕"}
                                            </span>
                                        </th>
                                        {/* <th style={{ textAlign: "left", padding: "8px" }}>zonedcodelocal</th> */}

                                        {/* <th style={{ textAlign: "left", padding: "8px", maxWidth: "140px" }}>Listed Sale</th> */}
                                    </tr>
                                </thead>

                                <tbody>
                                    {sortedParcels.map((item, i) => {
                                        const p = item || {};
                                        // const parcelId = p.parcel || p.parcelid || p.geo_id || p.id || `row-${i}`;
                                        // const isSelected = selectedParcelId === parcelId;


                                        // compute adjacent id from property
                                        const parcel = p.parcel || p.parcelid || p.geo_id || p.id || "";
                                        const adjacent = p.touching_parcel || p.adjacent_parcel || null;

                                        // Match the composite key logic from NCComponent.handleRowClick
                                        const rowKey = isAdjacentMode ? `${parcel}-${adjacent || ''}` : parcel;
                                        const isSelected = String(rowKey) === String(selectedParcelId);

                                        return (
                                            <tr
                                                //  key={parcelId}
                                                key={rowKey + i}
                                                onClick={() => handleRowClick(p, i)}
                                                // style={{ background: i % 2 === 0 ? "#fff" : "#f9f9f9", borderBottom: "1px solid #f0f0f0" }}
                                                style={{
                                                    background: isSelected
                                                        ? "#dcedeb" //  Highlight selected row
                                                        : i % 2 === 0
                                                            ? "#fff"
                                                            : "#f9f9f9",
                                                    borderBottom: "1px solid #f0f0f0",
                                                    cursor: "pointer", //  Show clickable cursor
                                                    transition: "background 0.2s ease", //  Smooth transition
                                                }}
                                                onMouseEnter={(e) => {
                                                    // ✅ Hover effect
                                                    if (!isSelected) {
                                                        e.currentTarget.style.background = "#f5f5f5";
                                                    }
                                                }}
                                                onMouseLeave={(e) => {
                                                    // ✅ Remove hover effect
                                                    if (!isSelected) {
                                                        e.currentTarget.style.background =
                                                            i % 2 === 0 ? "#fff" : "#f9f9f9";
                                                    }
                                                }}
                                            >

                                                <td style={{ textAlign: "center", padding: "8px", fontWeight: "500", color: "#666" }}>{i + 1}</td>
                                                <td style={{ padding: "8px", ...(isAdjacentMode ? { width: "120px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" } : {}) }}>{
                                                    isAdjacentMode
                                                        ? 
                                                        // [p.parcel || "N/A", (p.touching_parcel || p.adjacent_parcel) || null]
                                                        //     .filter(Boolean)
                                                        //     .join(" - ")
                                                         (<span 
                                                            title={
                                                                [p.parcel || "N/A", (p.touching_parcel || p.adjacent_parcel) || null]
                                                                    .filter(Boolean)
                                                                    .join(" - ")
                                                            }
                                                            style={{
                                                                display: "block",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                whiteSpace: "nowrap"
                                                            }}
                                                        >
                                                            {[p.parcel || "N/A", (p.touching_parcel || p.adjacent_parcel) || null]
                                                                .filter(Boolean)
                                                                .join(" - ")}
                                                        </span>
                                                    ) 
                                                        : (p.parcel || "N/A")
                                                }</td>
                                                <td style={{ textAlign: "center", padding: "8px" }}>{p.municipality || "N/A"}</td>
                                                <td style={{ textAlign: "right", padding: "8px" }}>
                                                    {p.parcelsize ? parseFloat(p.parcelsize).toFixed(2) : "N/A"}
                                                </td>
                                                <td style={{ textAlign: "right", padding: "8px" }}>{p.zonedcodelocal || "N/A"}</td>

                                                {/* <td style={{ textAlign: "right", padding: "8px" }}>
                                                {p.sqftrate ? `${p.sqftrate.toLocaleString()}` : "N/A"}
                                            </td> */}
                                                <td style={{ textAlign: "right", padding: "8px" }}>

                                                    {p.targetarv ? `$${parseFloat(p.targetarv).toLocaleString('en-US')}` : "N/A"}
                                                </td>
                                                <td style={{ textAlign: "right", padding: "8px" }}>
                                                    {p.landvalueperunit ? `$${parseFloat(p.landvalueperunit).toLocaleString('en-US')}` : "N/A"}

                                                </td>

                                                {isAdjacentMode && (
                                                    <td
                                                        style={{ textAlign: "right", padding: "8px" }}
                                                    >
                                                        20 +
                                                    </td>
                                                )}

                                                <td style={{ textAlign: "right", padding: "8px" }}>
                                                    {p.totalunits ? `${p.totalunits.toLocaleString()}` : "N/A"}
                                                </td>
                                                <td style={{ textAlign: "right", padding: "8px" }}>

                                                    {p.totallandvalue ? `$${parseFloat(p.totallandvalue).toLocaleString('en-US')}` : "N/A"}

                                                </td>
                                                <td style={{ textAlign: "right", padding: "8px" }}>
                                                    {p.zestimate ? `$${parseFloat(p.zestimate).toLocaleString('en-US')}` : "N/A"}
                                                </td>
                                                <td style={{ textAlign: "right", padding: "8px" }}>
                                                    {p.spread != null
                                                        ? p.spread < 0
                                                            ? `-$${Math.abs(p.spread).toLocaleString("en-US")}`
                                                            : `$${p.spread.toLocaleString("en-US")}`
                                                        : "N/A"}
                                                </td>
                                                <td style={{ textAlign: "right", padding: "8px" }}>
                                                    {p.spreadpercentage != null
                                                        ? p.spreadpercentage < 0
                                                            ? `-${Math.abs(p.spreadpercentage).toLocaleString("en-US")}`
                                                            : `${p.spreadpercentage.toLocaleString("en-US")}`
                                                        : "N/A"}
                                                </td>
                                                {/* <td style={{ textAlign: "left", padding: "8px" }}>
                                                {p.zonedcodelocal ? `${p.zonedcodelocal.toLocaleString()}` : "N/A"}
                                            </td> */}
                                            </tr>
                                        );
                                    })}


                                </tbody>
                            </table>

                            {/* Scroll target for infinite scroll */}
                            <div ref={loadMoreTargetRef} style={{ height: '20px' }}></div>

                            {/* Loading indicator when fetching more */}
                            {isLoadingMore && (
                                <div style={{
                                    padding: "20px",
                                    textAlign: "center",
                                    borderTop: "1px solid #e0e0e0",
                                    backgroundColor: "#f9f9f9"
                                }}>
                                    <div style={{
                                        display: "inline-block",
                                        width: "20px",
                                        height: "20px",
                                        border: "3px solid #f3f3f3",
                                        borderTop: "3px solid #1c8f7d",
                                        borderRadius: "50%",
                                        animation: "spin 1s linear infinite"
                                    }}></div>
                                    <style>{`
                                        @keyframes spin {
                                            0% { transform: rotate(0deg); }
                                            100% { transform: rotate(360deg); }
                                        }
                                    `}</style>
                                    <p style={{ marginTop: "10px", color: "#666", fontSize: "14px" }}>
                                        Loading more parcels...
                                    </p>
                                </div>
                            )}

                            {/* End of list indicator */}
                            {!hasMore && parcels.length > 0 && (
                                <div style={{
                                    padding: "20px",
                                    textAlign: "center",
                                    borderTop: "1px solid #e0e0e0",
                                    color: "#999",
                                    fontSize: "14px"
                                }}>
                                    All records loaded ({parcels.length} total)
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PropertyList;

